import React from 'react'

const ErrorPage = ({ des }) => {
    return (
        <p style={{ height: "80vh", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "20px" }}>{des}</p>
    )
}

export default ErrorPage